module.exports = __webpack_public_path__ + "static/filosofia-a9588e58f5a4db791e21da21b073186f.png";